import React, { useContext } from 'react';
import { graphql } from 'gatsby';
import AboutOhCleo from '../components/aboutOhCleo';
// import WorkForUs from '../components/workForUs';
// import HeroContentCreator from '../components/heroContentCreator';
import Layout from '../components/layout';
import { FullStore } from '../contexts/fullContext';
import ContentCreatorQuestions from '../components/contentCreatorQuestions';

const About = ({ data }) => {
  const { dispatch, state } = useContext(FullStore);

  const sections = data.sections.edges.reduce((all, one) => {
    const newAll = { ...all };
    newAll[one.node.contentfulid] = {
      ...one.node.childContentfulWebpageSectionContentJsonNode,
      images: one.node.images ? one.node.images : undefined,
    };
    return newAll;
  }, {});

  // const tracks = {
  //   pleaseMe: data.pleaseMe.edges.filter(item => item.node.demo === true),
  //   embraceMe: data.embraceMe.edges.filter(item => item.node.demo === true),
  //   educateMe: data.educateMe.edges.filter(item => item.node.demo === true),
  // };


  return (
    <Layout
      title="Become a content creator for OhCleo!"
      showBecomeContentCreator={false}
      showTransparentNav={false}
      showDarkStyling={true}>
      <AboutOhCleo section={sections.sectionWelcomeContentCreators} />
      <ContentCreatorQuestions section={sections.sectionWelcomeContentCreators}></ContentCreatorQuestions>
    </Layout>
  );
};

export default About;

export const query = graphql`
query {
  sections: allContentfulWebpageSection {
    edges {
      node {
        childContentfulWebpageSectionContentJsonNode {
          overline
          title
          subTitle
          body1
          body2
          box1Title
          box1Bodytext
          box2Title
          box2Bodytext
          sections {
            title
            intro
            subTitle1
            body1
            subTitle2
            body2
          }
        }
        contentfulid
        images {
          fluid(maxWidth: 680, resizingBehavior: FILL) {
            ...GatsbyContentfulFluid
          }
        }
      }
    }
  }
  pleaseMe: allContentfulTrack(filter: {subCategory: {contentful_id: {in: ["5JSbcU74kgmC0FBneyC1hm", "6lXgK347M9gUcbkX0fqeFd"]}}}) {
    edges {
      node {
        id
        title
        demo
        fileName
        episode
        duration
        description
        episode
        shortDescription
        series {
          title
          description
          coverImage {
            fluid(maxHeight: 300, maxWidth: 300, resizingBehavior: FILL) {
              ...GatsbyContentfulFluid
            }
          }
          fallbackCover {
            fluid(maxHeight: 300, maxWidth: 300, resizingBehavior: FILL) {
              ...GatsbyContentfulFluid
            }
          }
        }
        image {
          fluid(maxWidth: 115, maxHeight: 115, resizingBehavior: FILL) {
            ...GatsbyContentfulFluid
          }
        }
        subCategory {
          contentful_id
          parentCategory {
            name
          }
        }
      }
    }
  }
  educateMe: allContentfulTrack(filter: {subCategory: {contentful_id: {in: ["6Sp6vqvZ4WsrIOK7e71AKv"]}}}) {
    edges {
      node {
        id
        title
        demo
        fileName
        duration
        episode
        description
        episode
        shortDescription
        series {
          title
          description
          coverImage {
            fluid(maxHeight: 300, maxWidth: 300, resizingBehavior: FILL) {
              ...GatsbyContentfulFluid
            }
          }
          fallbackCover {
            fluid(maxHeight: 300, maxWidth: 300, resizingBehavior: FILL) {
              ...GatsbyContentfulFluid
            }
          }
        }
        image {
          fluid(maxWidth: 115, maxHeight: 115, resizingBehavior: FILL) {
            ...GatsbyContentfulFluid
          }
        }
        subCategory {
          contentful_id
          parentCategory {
            name
          }
        }
      }
    }
  }
  embraceMe: allContentfulTrack(filter: {subCategory: {contentful_id: {in: ["52IEVQO3b9ZJMbYPLr8iLn"]}}}) {
    edges {
      node {
        id
        title
        demo
        fileName
        duration
        description
        episode
        shortDescription
        series {
          title
          description
          coverImage {
            fluid(maxHeight: 300, maxWidth: 300, resizingBehavior: FILL) {
              ...GatsbyContentfulFluid
            }
          }
          fallbackCover {
            fluid(maxHeight: 300, maxWidth: 300, resizingBehavior: FILL) {
              ...GatsbyContentfulFluid
            }
          }
        }
        image {
          fluid(maxWidth: 115, maxHeight: 115, resizingBehavior: FILL) {
            ...GatsbyContentfulFluid
          }
        }
        subCategory {
          contentful_id
          parentCategory {
            name
          }
        }
      }
    }
  }
}
`;
